/**
 * The overlay renderer's side of the focus port (Part 05 Task 6). The
 * overlay draws straight from the presentation store, so applying changes
 * nothing outside it; revealing a frame on the workspace scrolls the wall to
 * its card and flashes it. Only the canvas renderer hides frames, so ending
 * an overlay presentation leaves the canvas store's focus-hidden set empty.
 */
import type { FocusAdapter } from "@/lib/focus/focus-adapter";
import { revealWallCard } from "@/lib/wall-reveal";
import { useCanvasStore } from "@/stores/canvas-store";

function restore(): void {
  const canvas = useCanvasStore.getState();
  if (canvas.focusHiddenFrameIds.size > 0) canvas.setFocusHiddenFrames([]);
}

export const overlayFocusAdapter: FocusAdapter = {
  apply: () => {},
  restore,
  revealOnWorkspace: (frameId) => revealWallCard(frameId),
};
